import axios from '@/http/index';

const base = '';
// 查询公告列表页展示功能
export const queryArticles = (id, params) => axios.get(`${base}/core/lookArticle/queryArticles?mainId=${id}`, params).then((res) => res.data);
// 查询员工查看公告详情功能
export const checkArticle = (params) => axios.get(`${base}/core/lookArticle/checkArticle`, params).then((res) => res.data);
// 查询员工查看公告详情功能
export const deleteArticle = (params) => axios.get(`${base}/core/lookArticle/deleteArticle`, params).then((res) => res.data);
// 新增公告功能
export const insertArticle = (id, params) => axios.post(`${base}/core/lookArticle/insertArticle?mainId=${id}`, params).then((res) => res.data);
// 修改公告功能
export const editArticle = (mainId, id, params) => axios.post(`${base}/core/lookArticle/editArticle?mainId=${mainId}&id=${id}`, params).then((res) => res.data);
